module.exports = __webpack_public_path__ + "img/huevo.80918087.png";